'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _AmazonVanguardLetters = require('./AmazonVanguardLetters.css');

var _AmazonVanguardLetters2 = _interopRequireDefault(_AmazonVanguardLetters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonVanguardPeerLetter = (_dec = (0, _reactCssModules2.default)(_AmazonVanguardLetters2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonVanguardPeerLetter, _Component);

  function AmazonVanguardPeerLetter(props) {
    (0, _classCallCheck3.default)(this, AmazonVanguardPeerLetter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonVanguardPeerLetter.__proto__ || (0, _getPrototypeOf2.default)(AmazonVanguardPeerLetter)).call(this, props));

    var letterTo = '';
    var letterSubject = 'Amazon 401(k) deforestation';
    var letterText = '\nDear [colleague],\n\nI just found out my 401(k) investments are funding companies that are burning down the Amazon rainforest.\n\nIt looks like most of us at Amazon are in the same boat - over 50% of the plan\u2019s assets are in the default option from Vanguard, which has millions invested in agribusiness companies like JBS and Bunge which source from farms that have been fined for illegal deforestation and slave labor practices in the Brazilian Amazon.\n\nThe data on the Amazon.com 401(k) can be found here:\nhttps://investyourvalues.org/retirement-plans/amazon-com\n\nI care about these issues and do not want my retirement savings to support companies that are destroying the environment.\n\nUnfortunately, we only have one sustainable investment option in the plan, and less than 2% of plan assets are invested in this option.\n\nWe\u2019ve taken a lot of positive steps as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon.\n\nIf you want to learn what\u2019s inside the 401(k) options at Amazon, you can visit the URL above.\n\nWe all have the power to support an economy that is based on justice and sustainability through our retirement investments.\n\nThank you for taking the time to listen, and look forward to hearing from you soon.\n\nSincerely,\n    ';

    var emailHref = 'mailto:' + letterTo + '?subject=' + encodeURIComponent(letterSubject) + '&body=' + encodeURIComponent(letterText);

    _this.state = {
      showPeerLetter: false,
      emailHref: emailHref
    };
    return _this;
  }

  (0, _createClass3.default)(AmazonVanguardPeerLetter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showPeerLetter = _state.showPeerLetter,
          emailHref = _state.emailHref;
      //

      return _react2.default.createElement(
        'div',
        { styleName: 'letter-box' },
        _react2.default.createElement(
          'div',
          { styleName: 'letter-box-flex' },
          _react2.default.createElement(
            'div',
            { styleName: 'letter-box-label' },
            _react2.default.createElement(
              'h2',
              null,
              'Send a message to your peers'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Send a message to your coworkers and colleagues asking them to join in asking Amazon management for a deforestation-free 401(k).'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'button',
                {
                  styleName: 'show-letter-button',
                  onClick: function onClick() {
                    _this2.setState({ showPeerLetter: !showPeerLetter });
                  }
                },
                'Letter to peers',
                _react2.default.createElement(_.LinkIcon, {
                  faclass: showPeerLetter ? 'fa-angle-double-up' : 'fa-angle-double-down'
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-icons' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _.Link,
                {
                  to: emailHref,
                  title: 'Send a message to your colleagues',
                  log: _analytics2.default.eventStaffSupport('Amazon', 'peer_message_vanguard'),
                  targetBlank: true
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Email'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          showPeerLetter ? _react2.default.createElement(
            'blockquote',
            { styleName: 'company-letter-blockquote' },
            _react2.default.createElement(
              'p',
              null,
              'Dear ',
              _react2.default.createElement(
                'b',
                null,
                '[colleague],'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'I just found out my 401(k) investments are funding companies that are burning down the Amazon rainforest.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'It looks like most of us at Amazon are in the same boat - over 50% of the plan\u2019s assets are in the default option from Vanguard, which has millions invested in agribusiness companies like JBS and Bunge which source from farms that have been fined for illegal deforestation and slave labor practices in the Brazilian Amazon.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The data on the Amazon.com 401(k) can be found here:',
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.routes.plans + '/amazon-com',
                  title: 'Amazon.com retirement plan sustainability scorecard',
                  xstrong: true
                },
                'https://investyourvalues.org/retirement-plans/amazon-com'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'I care about these issues and do not want my retirement savings to support companies that are destroying the environment.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Unfortunately, we only have one sustainable investment option in the plan, and less than 2% of plan assets are invested in this option.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We\u2019ve taken a lot of positive steps as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon. '
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you want to learn what\u2019s inside the 401(k) options at Amazon, you can visit the URL above. '
            ),
            _react2.default.createElement(
              'p',
              null,
              'We all have the power to support an economy that is based on justice and sustainability through our retirement investments. '
            ),
            _react2.default.createElement(
              'p',
              null,
              'Thank you for taking the time to listen, and look forward to hearing from you soon.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Sincerely,',
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                '[Your Name]',
                _react2.default.createElement('br', null),
                '[Your contact information: company department, email, phone, etc.]'
              )
            )
          ) : null
        )
      );
    }
  }]);
  return AmazonVanguardPeerLetter;
}(_react.Component)) || _class);
exports.default = AmazonVanguardPeerLetter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonVanguardLetters/AmazonVanguardPeerLetter.js
// module id = 1373
// module chunks = 0